import { env } from '~/env'

export const isWinGoogleChrome = (): boolean => {
  const isChrome =
    /Chrome/.test(navigator.userAgent) && !/Edg|Edge|OPR|Brave/.test(navigator.userAgent)
  const isWindows = /Windows/.test(navigator.userAgent)
  return isWindows && isChrome
}

export const getFirefoxVersion = (): number | null => {
  const ua = navigator.userAgent
  const match = ua.match(/Firefox\/(\d+)\./)
  return match ? parseInt(match[1], 10) : null
}

export const getSubdomain = (): string | null => {
  const isProduction = env.VITE_ENV === 'prod'

  if (!isProduction) {
    return 'acme'
  }

  const url = window.location.href
  const domain = new URL(url).hostname
  const splitted = domain.split('.')

  if (splitted.length >= 3) {
    return splitted[0]
  }

  return null
}
